import { FC, memo } from 'react'
import s from './Radio.module.sass'
import { RadioOption } from '@shared/types/fields/fields'
import { BlockBoundary } from '../../../../lib/components/BlockBoundary'
import { Text } from '@shared/ui/Typography/Text'

interface Props {
  option: RadioOption
  checked: boolean

  handleClick: (value: RadioOption) => void
  className?: string
  mode?: 'checkbox' | 'button' | 'radio'
}

const Radio: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLLabelElement>, HTMLLabelElement>> = ({
  option,
  checked,
  handleClick,
  mode = 'checkbox',
  className,
  ...props
}) => {
  const handleChangeInner = () => {
    handleClick && handleClick(option)
  }

  const labelClassname =
    mode === 'radio' ? `${s['radio-label']} ${className || ''}` : `${s.button} ${s[mode]} ${className || ''}`

  return (
    <BlockBoundary>
      <label className={labelClassname} data-disabled={option.disabled} data-checked={checked} {...props}>
        <input
          type='radio'
          id={option.id}
          name={option.name}
          value={option.value}
          disabled={option.disabled}
          checked={checked}
          onChange={handleChangeInner}
          hidden
        />
        {mode === 'radio' && <span className={s['radio-indicator']} />}
        <Text sizes={'M'}>{option.label}</Text>
      </label>
    </BlockBoundary>
  )
}

export default memo(Radio)
